export const environment = {
	production: false,
	url: "https://api-crm.policystreet.app",
	amsUrl: "https://api-ams.policystreet.app",
};
